export const state = {
  oils: [],
  grn_item_orders: [
    {
      product_id: "",
      cartons_qty: "",
      cartons_litres: "",
      total_qty: "",
      remarks: ""
    }
  ],
  systemOilreceiving:[]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/oils/state.js